/** @file Depth bias of an impostor: zOrder, the pick's side/back offset, the entry's own offset (4.3, 22.4). */
import { Z_BIAS_UNIT } from '@zilo/pose3d-render-core/depth/zBiasUnit';

/** `(zOrder + depthOffset + entryOffset) * Z_BIAS_UNIT`, subtracted from depth (positive = nearer). */
export function zBiasOf(zOrder: number, depthOffset: number, entryOffset = 0): number {
  return (zOrder + depthOffset + entryOffset) * Z_BIAS_UNIT;
}
